import { Dialog, DialogProps } from '@material-ui/core';
import React from 'react';
import { IModalWindow } from '@hooks/useModalWindow';
import { LoadingBackdrop } from '../LoadingBackdrop';

export type CloseMode = "backdropClick" | "escapeKeyDown" | "closeButton";

export type CloseEventHandler = (closeMode: CloseMode) => void

export type ModalWindowProps = Omit<DialogProps, "open" | "disableBackdropClick"> & {
    modal: IModalWindow
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
    disableBackdropClick?: boolean
    disabled: boolean
    onModalClose?: CloseEventHandler
}

export const ModalWindowContext = React.createContext<(IModalWindow & {onModalClose?: CloseEventHandler}) | undefined>(undefined);

export function ModalWindow ({ modal, size, children, disableBackdropClick, disabled, onModalClose, ...props}: ModalWindowProps) {
    const handleClose = React.useCallback((event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (!disabled && disableBackdropClick === false) {
            modal.close();
            
            if (onModalClose !== undefined) {
                onModalClose(reason);
            }
        }
    }, [disableBackdropClick, disabled, modal, onModalClose]);

    return (
        <Dialog
            {...props}
            onClose={handleClose}
            open={modal.isOpen}
            fullWidth={size !== undefined}
            maxWidth={size}
        >
            <ModalWindowContext.Provider value={{...modal, onModalClose}}>
                { children }
            </ModalWindowContext.Provider>

            {
                disabled === true && (
                    <LoadingBackdrop isLoading={true} />
                )
            }
        </Dialog>
    )
}